import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
// import Delete from '@/Custom_Icons/Delete.vue'
// import Edit from '@/Custom_Icons/Edit.vue'
// import Gallery from '@/Custom_Icons/Gallery.vue'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        background: '#F5F5F5',
        primary: '#009CDE',
        secondary: '#9FB700',
        blue_accent: '#00587d',
        accent: '#444444',
        error: '#de0000',
        success2: '#4CAF50',
        purple: "#8850BF",
        white_highlight: "#FFFFFF",
        warning: '#f59b42',
        blue_dashboard: "#259ce6",
        grey: '#707070',
        fill_back_green: "#e2fce8",
        fill_back_red: "#fccaca",
        filled_accent: "#444444",
        horizontal_separator: '#d7d1d1',
        yellow: '#ffa64d',
        red: '#ff0200',
        headers: '#888888'
      },
    // ALL COLOR NAMES MAKES REFERENCE TO COLORS OF LIGHT THEME
      dark: {
        background: '#121212',
        primary: '#03A9F4',
        secondary: "#BAD600",
        blue_accent: "#30A9C1",
        accent: "#e0e0e0",
        error: '#E64A4A',
        success2: '#4CAF50',
        purple: "#8850BF",
        white_highlight: "#444444",
        warning: '#f59b42',
        blue_dashboard: "#259ce6",
        grey: '#707070',
        fill_back_green: "#1b400a",
        fill_back_red: "#712222",
        filled_accent: "#444444",
        horizontal_separator: '#464343',
        yellow: '#ffa64d',
        red: '#E64A4A',
        headers: '#E5E5E5'
      }
    },
    
  },
  icons: {
    iconfont: 'md',
    // values: {
    //   Delete: { // name of our custom icon
    //     component: Delete, // our custom component
    //   },
    //   Edit: { // name of our custom icon
    //     component: Edit, // our custom component
    //   },
    //   Gallery: { // name of our custom icon
    //     component: Gallery, // our custom component
    //   },
    // },
  },
});
